module.exports = __webpack_public_path__ + "img/c-partners-6.png";